export const completeUrl = (url) => {
  if (!!~url.indexOf("/", 2) || url.indexOf("http") === 0) {
    return url;
  }
  return `https://${url.toLowerCase()}/`;
};
